import { useEffect, useMemo, useRef } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { getTabTitle } from './helpers/getTabTitle';
import { toolIdToTranslatedKey } from './helpers/toolIdToTranslatedKey';
export const HeadlessTabTitle = _ref => {
  let {
    productId,
    toolId,
    value,
    restoreOriginalTitle = true
  } = _ref;
  const {
    current: oldTitle
  } = useRef(document.title);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const translatedToolId = useMemo(() => {
    var _T$translate;
    if (!toolId) {
      return undefined;
    }
    const translationKey = toolIdToTranslatedKey(toolId);
    const translatedToolTitle = (_T$translate = T.translate(translationKey)) === null || _T$translate === void 0 ? void 0 : _T$translate.toString();
    if (translatedToolTitle === translationKey) {
      console.warn("Translation for ".concat(toolId, " is missing"));
      return undefined;
    }
    return translatedToolTitle;
  }, [T, toolId]);
  const title = useMemo(() => getTabTitle({
    productId,
    toolTitle: translatedToolId,
    additionalInformation: value
  }), [translatedToolId, productId, value]);
  useEffect(() => {
    document.title = title;
  }, [title]);
  useEffect(() => {
    return () => {
      if (restoreOriginalTitle) {
        document.title = oldTitle;
      }
    };
  }, [oldTitle, restoreOriginalTitle]);
  return null;
};
//# sourceMappingURL=HeadlessTabTitle.js.map